import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import Vuex from "vuex";

import VueCookies from "vue-cookies";

import user from "./store/user";
import rob from "./store/rob";
import general from "@/store/general";
import structure from "@/store/structure";
import carte from "@/store/carte";
import ligneRob from "@/store/ligneRob";
import ligneRobCom from "@/store/ligneRobCom";
import commande from "@/store/commande";
import relance from "@/store/relance";
import typeRelance from "@/store/typeRelance";
import link from "@/store/link";
import dr from "@/store/dr";
import safir from "@/store/safir";
import tva from "@/store/tva";

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueCookies);
Vue.$cookies.config("30d");

const store = new Vuex.Store({
  modules: {
    user,
    rob,
    general,
    structure,
    carte,
    ligneRob,
    ligneRobCom,
    commande,
    relance,
    link,
    dr,
    safir,
    tva,
    typeRelance,
  },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
